import React from 'react';
import { useForm } from 'react-hook-form';
import { FIELDS, STEPS } from '../utils/constants';
import { useFormStateContext } from '../utils/hooks';
import {
  InputField,
  InputError,
  InputContainer,
  InputLabel,
  Flex,
  Button,
} from '../utils/styles';

export const SuccessStep = () => {
  const { fields, setStep, updateFields } = useFormStateContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { successstep: fields.successstep } });

  // const goBack = () => { 
  //   setStep(STEPS.MOBILE);
  // };

  // const onSubmit = (data) => {
  //   console.log(data);
  //   updateFields(FIELDS.SUCCESSSTEP, data.successstep);
  //   setStep(STEPS.COUNTRYCODE);
  // };

  const onError = (errors, event) => {
    console.log(errors);
    console.log(event);
  };

  return (
    <div className="base-form">
      {/* <form onSubmit={handleSubmit(onSubmit, onError)}> */}
      <form onSubmit={handleSubmit( onError )}>
      <div className='button-back'>
          <Button
            type="button"
            children="Back"
            secondary
            style={{ margin: '0 10px' }}
           
          > </Button>  
          <h4>You are logged in now</h4>    
        </div> 
        <div className="f-container">
         
          <h1 className='rejtion-title'>Register Successsfully</h1>
          <div className="for-button-manage">

            <div>
               <div className='button-next home-btn'>
                <a href="/">
                 Home
                </a> 
              </div>
               <div className='button-next home-btn'>
                <a href="/user-profile">
                  Complete Profile
                </a>             
              </div>
            </div>
            {/* <div className='button-next'>
              <a href="/?login"  children="" >Login Now <span className="enter"></span>  <i class="fa-solid fa-arrow-right"></i></a>
            </div> */}
          </div>
        </div>
      </form>
    </div>
  );
};
